<template>
  <div class="choose-icon">
    <span class="iconfont">√</span>
  </div>
</template>
<script>
export default {
  name: 'choose-icon',
}
</script>
<style lang="scss" scoped>
.choose-icon {
  width: 11px;
  height: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(5, 126, 255, 1);
  position: absolute;
  bottom: 1px;
  right: 1px;
  .iconfont {
    font-size: 12px;
    transform: scale(0.8);
    color: #fff;
  }
}
</style>
